export default {"src":"/_next/static/image/public/assets/search.8d7fd989b667cbb0c0a6ad57ae357e1e.svg","height":30,"width":30};